<template>
<DashBoardLayout>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</DashBoardLayout>
</template>

<script>
import DashBoardLayout from '../layouts/DashboardLayout.vue'

export default {
  components:{DashBoardLayout},
}
</script>
